import {ThumbsCamera} from "features/apartmentViewer/types";

export class ThumbNailModel {
    get viewId(): string {
        return this._viewId;
    }

    set viewId(value: string) {
        this._viewId = value;
    }

    private _viewId: string;

    get description(): string {
        return this._description;
    }

    set description(value: string) {
        this._description = value;
    }
    private _description: string;

    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
    }
    private _title: string;

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    private _id: string;

    constructor(
        thumbNail: ThumbsCamera
    ) {
        this._id = thumbNail.id;
        this._title = thumbNail.title;
        this._description = thumbNail.description;
        this._viewId = thumbNail.v;

    }
}
